import * as types from '../mutation-types'

const state = {
  sellers: null
}

const getters = {
  sellers: state => state.sellers
}

const actions = {
  setSellers (state, sellerList) {
    const sellers = sellerList.reduce((m, s) => {
      m[s.sellerId.value] = s
      return m
    }, {})
    state.commit(types.SET_SELLERS, sellers)
  }
}

const mutations = {
  [types.SET_SELLERS] (state, sellers) {
    state.sellers = sellers
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/sellers.js